import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _someInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/some";
import _trimInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/trim";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import stubTrue from "lodash/stubTrue";
import get from "lodash/get";
export const createTextFilter = filterValue => {
  var _context;
  const words = _filterInstanceProperty(_context = _trimInstanceProperty(filterValue).call(filterValue).toLowerCase().split(' ')).call(_context, Boolean);
  if (!words.length) {
    return stubTrue;
  }
  return text => {
    const lowerText = text.toString().toLowerCase();
    return _someInstanceProperty(words).call(words, word => _includesInstanceProperty(lowerText).call(lowerText, word));
  };
};
export const defaultColumnFilter = (filterValue, {
  path
}) => {
  const textFilter = createTextFilter(filterValue);
  return item => textFilter(get(item, path, ''));
};